<template>
  <input />
</template>
<script>
//http://ionden.com/a/plugins/ion.rangeSlider/index.html
import $ from "jquery";
require("ion-rangeslider");
require("ion-rangeslider/css/ion.rangeSlider.min.css")
export default {
  name: "pdkRange",
  props: {
    values: { type: Array },
    hideMinMax: { type: Boolean, default: true },
    keyboard: { type: Boolean, default: true },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    from: { type: Number, default: 0 },
    to: { type: Number },
    type: { type: String },
    step: { type: Number, default: 1 },
    prefix: { type: String, default: null },
    postfix: { type: String, default: null },
    grid: { type: Boolean, default: false },
  },
  mounted: function () {
    const vm = this;
    $(this.$el).ionRangeSlider({
      hide_min_max: this.hideMinMax,
      keyboard: this.keyboard,
      values: this.values,
      min: this.min,
      max: this.max,
      from: this.from,
      to: this.to,
      type: this.type,
      step: 1,
      prefix: this.prefix,
      postfix: this.postfix,
      grid: this.grid,
      onStart: function (data) {
        vm.$emit("onStart", {
          from: data.from,
          fromValue: data.from_value,
          fromPrecent: data.from_percent,
          fromPretty: data.from_pretty,

          to: data.to,
          toValue: data.to_value,
          toPrecent: data.to_percent,
          toPretty: data.to_pretty,

          min: data.min,
          max: data.max,
        });
      },
      onChange: function (data) {
        vm.$emit("onChange", {
          from: data.from,
          fromValue: data.from_value,
          fromPrecent: data.from_percent,
          fromPretty: data.from_pretty,

          to: data.to,
          toValue: data.to_value,
          toPrecent: data.to_percent,
          toPretty: data.to_pretty,

          min: data.min,
          max: data.max,
        });
      },
      onFinish: function (data) {
        vm.$emit("onFinish", {
          from: data.from,
          fromValue: data.from_value,
          fromPrecent: data.from_percent,
          fromPretty: data.from_pretty,

          to: data.to,
          toValue: data.to_value,
          toPrecent: data.to_percent,
          toPretty: data.to_pretty,

          min: data.min,
          max: data.max,
        });
      },
      onUpdate: function (data) {
        vm.$emit("onUpdate", {
          from: data.from,
          fromValue: data.from_value,
          fromPrecent: data.from_percent,
          fromPretty: data.from_pretty,

          to: data.to,
          toValue: data.to_value,
          toPrecent: data.to_percent,
          toPretty: data.to_pretty,

          min: data.min,
          max: data.max,
        });
      },
    });
  },
};
</script>
<style >
.irs--flat .irs-from, .irs--flat .irs-to, .irs--flat .irs-single {
    color: white;
    font-size: 10px;
    line-height: 1.333;
    text-shadow: none;
    padding: 1px 5px;
    border-radius: 4px;
        background-color: #07557c !important;
    direction: ltr  !important;
}
.irs--flat .irs-handle>i:first-child {
  background-color: #07557c !important;
}
.irs-from:after, .irs-single:after, .irs-to:after{
      border-top-color: #07557c !important;
}
</style>